var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 41,
    viewBox: "0 0 39px 41px",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0C16.9392 0 14.4035 0.520383 12.0377 1.53144C9.67182 2.54249 7.52216 4.02441 5.71142 5.8926C2.05446 9.66556 0 14.7828 0 20.1186C0 25.4544 2.05446 30.5716 5.71142 34.3446C7.52216 36.2127 9.67182 37.6947 12.0377 38.7057C14.4035 39.7168 16.9392 40.2372 19.5 40.2372C24.6717 40.2372 29.6316 38.1175 33.2886 34.3446C36.9455 30.5716 39 25.4544 39 20.1186C39 17.4766 38.4956 14.8604 37.5157 12.4195C36.5357 9.97863 35.0993 7.76078 33.2886 5.8926C31.4778 4.02441 29.3282 2.54249 26.9623 1.53144C24.5965 0.520383 22.0608 0 19.5 0ZM27.69 28.5684L17.55 22.1304V10.0593H20.475V20.521L29.25 25.953L27.69 28.5684Z",
    fill: "#D6AF4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.b7a2ecd69404acfb24a01b8c2ed27e95.svg";
export { ForwardRef as ReactComponent };